<template>
    <div class="container"  v-title="'新闻'">
        <div class="container_content">
            <div class="news_channel" v-if="channels.length > 0" v-scrollShadow="scrollTop" ref="newsChannels">
                <Scroll direction="horizontal" :scroll.sync="tabScroll">
                    <ul ref="channelBox" :style="tabStyle">
                        <li v-for="item,index in channels" :key="index" 
                        ref="channelItem"
                        :class="{
                            'active': item.id == activeChannelId
                        }"
                        ><span @click="select(item.id, index)">{{item.name}}</span></li>
                    </ul>
                </Scroll>
            </div>
            <div id="News_home">
                <template v-for="item,index in channels">
                    <template v-if="loadChannelIds.includes(item.id)">
                        <ChannelLayout
                            :ref="'channelLayout_' + item.id"
                            :channelUrl="item.url"
                            :channelId="item.id"
                            :key="index"
                            v-show="item.id == activeChannelId"
                            @playVideo="playVideoDom = $event"
                            @scrollChange="scrollTop = $event"
                            :isHome="!!item.isHome"
                        ></ChannelLayout>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import appInteraction from '@/common/appInteraction.js';
import ChannelLayout from './components/ChannelLayout.vue';
let timer = null;
export default {
    name:"NewsHome",
    components:{
        ChannelLayout
    },
    data(){
        return {
            scrollTop: 0,
            tabScroll: 0,
            tabStyle: {},
            channels: [],
            activeChannelId: 0,
            loadChannelIds: [],
            playVideoDom: null
        }
    },
    created(){
        this.$api.json(process.env.VUE_APP_NEWS_HOME_CMS_URL).then(data=>{
            let channels = data.channels || [];
            this.channels = channels;
            this.select(channels[0].id, 0)
        }).catch(()=>{});
        appInteraction.backTop(()=>{
            this.$refs['channelLayout_' + this.activeChannelId][0].setScroll(0);
        })
    },
    mounted(){
        var _this = this;
        window.onblur = ()=>{
            if(_this.playVideoDom){
                _this.playVideoDom.pause();
            }
        }
    },
    destroyed(){
        window.onblur = null;
    },
    methods:{
        select(id, index){
            if(!this.loadChannelIds.includes(id)){
                this.loadChannelIds.push(id);
            }
            let oldId = this.activeChannelId;
            if(this.activeChannelId != id){
                this.activeChannelId = id;
                if(this.playVideoDom){
                    this.playVideoDom.pause();
                }
                this.$nextTick(function(){
                    this.$refs['channelLayout_' + this.activeChannelId][0].setScroll(0);
                    if(oldId != 0){
                        this.setTabScroll(index);
                    }
                });
            }else{
                this.$refs['channelLayout_' + this.activeChannelId][0].setScroll(0);
            }
        },
        setTabScroll(index){
            let newsChannelsW = this.$refs.newsChannels.clientWidth;
            let channelBoxW = this.$refs.channelBox.clientWidth;
            let maxL = channelBoxW - newsChannelsW;
            if(maxL < 0) return;
            let channelItem = this.$refs.channelItem[index];
            let left = channelItem.offsetLeft, width = channelItem.offsetWidth;
            let newScroll = 0, oldScroll = this.tabScroll;
            if(newsChannelsW / 2 < left + width / 2){
                let MLeft = (left + width / 2) - (newsChannelsW / 2);
                newScroll = MLeft > maxL ? maxL : MLeft;
            }else{
                let MLeft = (newsChannelsW / 2) - (left + width / 2);
                newScroll = MLeft > 0 ? 0 : MLeft;
            }
            if(newScroll != oldScroll){
                let move = oldScroll - newScroll;
                let time = (Math.abs(move) * 0.001 + 0.1).toFixed(2);
                this.tabStyle = {
                    transition: time + 's ease-out',
                    left: move + 'px',
                }
                clearTimeout(timer);
                timer = setTimeout(()=>{
                    this.$nextTick(function(){
                        this.tabStyle = {};
                        this.tabScroll = newScroll;
                    })
                }, time * 1000)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.news_channel{
    $w:100%;
    $h:80px;
    width: $w;
    height: $h;
    position: relative;
    z-index: 10;
    &::after{
        content: '';
        width: 100%;
        border-bottom: 1px #E5E5E5 solid;
        position: absolute;
        bottom: 0;
        left: 0;
    }
    ul{
        width: auto;
        height: $h;
        padding-left: 40px;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        white-space: nowrap;
        position: relative;
        left: 0;
        li{
            width: auto;
            @include line-height($h);
            font-size: 28px;
            color: #666666;
            font-weight: 400;
            margin-right: 24px;
            display: inline-block;
            vertical-align: middle;
            transition: 0.3s linear;
            &.active{
                font-size: 32px;
                color: #7AD21A;
                font-weight: 500;
                border-bottom: 2px #7AD21A solid;
                box-sizing: border-box;
            }
            span{
                white-space: nowrap;
            }
        }
    }
}
#News_home{
    height: calc(100% - 80px);
}
</style>